import AxiosInstanceCreator from 'services/api';
import qs from 'qs';
const authInstance = new AxiosInstanceCreator().create();

export const codeApi = {
  async getCodeList(param: any) {
    return await authInstance.get(`/code/list?${qs.stringify(param)}`).then((res) => res.data);
  },
  async getCodeDetail(codeId: any) {
    return await authInstance.get(`/code/find?codeId=${codeId}`).then((res) => res.data);
  },
  /**
   * Man Power
   * @param formCode
   */
  async getManpowerCodeList(formCode?: string) {
    var param = {
      groupType: 'MANPOWER',
      groupSubType: formCode
    };
    return await codeApi.getCodeList(param);
  },
  /**
   * 공종, 세부1, 세부2
   * @param parentCodeId
   */
  async getDiscpCodeList(parentCodeId?: string) {
    var param = {
      groupType: 'DISCP',
      parentCodeId: parentCodeId
    };
    return await codeApi.getCodeList(param);
  },
  async saveCode(param: any) {
    return await authInstance.post(`/code/save`, param).then((res) => res.data);
  },
  async deleteCode(param: any) {
    return await authInstance.post(`/code/delete`, param).then((res) => res.data);
  }
};
